import { useState, type FormEvent } from 'react';
import { faqAPI, type FAQ } from '../../services/api';
import toast from '../Toast';

interface FAQFormProps {
  faq: FAQ | null;
  onClose: () => void;
  onSuccess: () => void;
}

export default function FAQForm({ faq, onClose, onSuccess }: FAQFormProps) {
  const [form, setForm] = useState({
    question: faq?.question || '',
    answer: faq?.answer || '',
    sortOrder: faq?.sortOrder || 0,
    isActive: faq?.isActive ?? true,
  });

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      if (faq) {
        await faqAPI.updateFAQ(faq.id, form);
      } else {
        await faqAPI.createFAQ(form);
      }
      onSuccess();
    } catch (error) {
      toast.error('保存失败');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="text-sm font-medium text-light-text mb-1.5 block">问题</label>
        <input
          type="text"
          value={form.question}
          onChange={(e) => setForm({ ...form, question: e.target.value })}
          placeholder="输入问题"
          className="w-full bg-white border border-light-border rounded-xl px-4 py-3 text-light-text"
          required
        />
      </div>
      <div>
        <label className="text-sm font-medium text-light-text mb-1.5 block">答案</label>
        <textarea
          value={form.answer}
          onChange={(e) => setForm({ ...form, answer: e.target.value })}
          placeholder="输入答案"
          rows={4}
          className="w-full bg-white border border-light-border rounded-xl px-4 py-3 text-light-text resize-none"
          required
        />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className="text-sm font-medium text-light-text mb-1.5 block">排序</label>
          <input
            type="number"
            value={form.sortOrder}
            onChange={(e) => setForm({ ...form, sortOrder: parseInt(e.target.value) || 0 })}
            className="w-full bg-white border border-light-border rounded-xl px-4 py-3 text-light-text"
          />
        </div>
        <div className="flex items-center">
          <label className="mt-0 flex items-center gap-2 rounded-xl border border-light-border bg-light-hover/30 px-4 py-3 sm:mt-6">
            <input
              type="checkbox"
              checked={form.isActive}
              onChange={(e) => setForm({ ...form, isActive: e.target.checked })}
              className="w-4 h-4 rounded border-light-border"
            />
            <span className="text-sm text-light-text">启用</span>
          </label>
        </div>
      </div>
      <div className="flex flex-col-reverse gap-3 pt-4 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={onClose}
          className="w-full px-4 py-2 text-light-muted transition-colors hover:text-light-text sm:w-auto"
        >
          取消
        </button>
        <button
          type="submit"
          className="w-full rounded-xl bg-accent-blue px-6 py-2 font-medium text-white transition-all hover:shadow-lg sm:w-auto"
        >
          保存
        </button>
      </div>
    </form>
  );
}
